enum KbaStatus {
  ALREADY_PASSED
  EXCEEDED_ATTEMPT_LIMIT
  QUESTIONNAIRE_NOT_FOUND
  SUCCESS
}

type KbaAttempt {
  attempt_id: ID
  status: KbaStatus!
  questions: [KbaQuestion!]
}

type KbaQuestion {
  id: ID!
  text: String
  header: String
  choices: [KbaChoice!]!
}

type KbaChoice {
  id: ID!
  text: String!
}

input KbaAnswer {
  choice_id: Int!
  question_id: Int!
}

input KbaInput {
  attempt_id: ID!
  answers: [KbaAnswer!]!
}

enum KbaDecision {
  INVALID
  FAIL
  PASS
  IN_PROGRESS
  UNDECISIONED
}

type KbaSubmissionResponse {
  attempts_remaining: Int!
  decision: KbaDecision!
  second_questionnaire: KbaAttempt
}
